/* libs */
import { createLogic } from "redux-logic";
/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as appsActions from "../../actions/appsActions";

const editAppSuccessLogic = createLogic({
	type: ActionTypes.EDIT_APP_SUCCESS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(appsActions.loadApps());
		done();
	},
});

export default [editAppSuccessLogic];
